import Slider from "react-slick";
import styled from "styled-components";

export const Container = styled.div`
  width: 100vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (min-width: 768px) {
    max-width: calc(100% - 18vw);
  }
`;

export const JourneyCard = styled.div`
  display: flex;
  margin: 16px 8px;
  padding: 16px !important;
  flex-direction: column;
  gap: 8px;
  box-shadow: 0px 7px 8px 0px rgba(0, 0, 0, 0.05),
    0px 5px 22px 4px rgba(0, 0, 0, 0.05), 0px 12px 17px 2px rgba(0, 0, 0, 0.05);
  background-color: white;
  border-radius: 16px;

  @media only screen and (max-height: 667px) {
    margin-top: 8px;
    margin-bottom: 8px;
  }
`;

export const TitleDescription = styled.div`
  margin-top: 20px;
  padding-left: 20px;
  width: 100%;

  @media only screen and (min-width: 768px) {
    margin-top: 13vh;
  }
`;

export const SliderContainer = styled.div`
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
`;

export const JourneyCardTitle = styled.div`
  display: flex;
  justify-content: space-between;
  height: 14px;
  align-items: center;

  h1 {
    font-size: 14px;
    font-weight: bold;
    color: #1f2d3d;
    margin: 0;
    padding: 0;
  }

  p {
    font-size: 11px;
    font-weight: normal;
    color: #1f2d3d;
    margin: 0;
    padding: 0;
  }
`;

export const MediaContainer = styled.div`
  width: auto;
  background-color: #ece7e7;
  border-radius: 16px;
  height: 159px;

  .media-player iframe {
    width: 100%;
    height: 159px;
    border-radius: 16px;
  }
`;

export const JourneyCardBody = styled.div`
  display: flex;
  margin: 16px 0;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #f0f2f9;
  background-color: #fff;

  @media only screen and (max-height: 667px) {
    margin: 8px 0;
    gap: 8px;
  }
`;

export const JourneyCardTab = styled.div`
  display: flex;
  margin: 0;
  height: 32px;
  width: 100%;
  margin-bottom: 8px;
  border-bottom: 1px solid #ece7e7;

  @media only screen and (max-height: 667px) {
    height: 28px;
  }
`;

export const TabButton = styled.div`
  width: 50%;
  font-size: 12px;
  text-align: center;
`;

export const TabButtonDivider = styled.div`
  position: relative;
  top: 9px;
  height: 4px;
  background-color: #00bcf1;
  border-radius: 4px;

  @media only screen and (max-height: 667px) {
    top: 5px;
  }
`;

export const TabContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;

  @media only screen and (max-height: 667px) {
    row-gap: 6px;
  }
`;

export const TabContent = styled.div`
  display: flex;
  column-gap: 16px;
  align-items: center;
  height: 26px;

  p {
    top: 2px;
    position: relative;
    font-size: 11px;
    font-weight: bold;
    margin: 0px !important;
    padding: 0px !important;
    line-height: 14px;
  }

  div {
    top: 2px;
    position: relative;
    font-size: 11px;
    font-weight: bold;
    margin: 0px !important;
    padding: 0px !important;
    line-height: 14px;
    width: 65%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media screen and (min-width: 1030px) {
      div {
        width: 100%;
      }
    }
  }
`;

export const Carousel = styled(Slider)`
  &.slick-slider {
    display: grid;
    cursor: pointer;
  }
  & .slick-prev:before,
  .slick-next:before {
    color: #00bcf1;
  }
`;

export const JourneyCardButton = styled.button`
  width: 100%;
  border: 1px solid #1f2d3d;
  border-radius: 40px;
  padding: 12px 16px;
  background-color: white;
  font-size: 16px;
  font-weight: bold;
  color: #1f2d3d;

  @media only screen and (max-height: 667px) {
    padding: 8px 12px;
  }
`;

export const DotsWrapper = styled.div`
  display: flex;
  margin: 16px 0;
  justify-content: center;
  width: 100%;
  height: 10px;
  column-gap: 4px;
`;

export const Dots = styled.div`
  width: ${(props) => (props?.isActive ? "16px" : "8px")};
  height: 8px;
  border-radius: 8px;
  background-color: ${(props) => (props?.isActive ? "#6a7481" : "#b8c1cb")};
`;
